import { fetcher } from '../../configure'
import { PlannedRoute } from './dto/planned-route.dto'


export type GetPlannedRoutesRequest = {
    guideId: string
}

export type GetPlannedRoutesResponse = {
	success: boolean
	routes: PlannedRoute[]
}

export type GetPlannedRoutesEndpoint = (
	request: GetPlannedRoutesRequest
) => Promise<GetPlannedRoutesResponse>

export const getPlannedRoutes: GetPlannedRoutesEndpoint = async (request) => {
	return await fetcher({
		method: 'get',
		path: `/users/planned-routes/${request.guideId}`,
		body: request, 
	})
}
